import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import {
  Checkbox,
  FormControlLabel,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { memo, useCallback, useState } from 'react';
import { useJobTitleExpanderStore } from '../../store';
import * as Styled from './styles';
import * as SX from './sx';
import type { CombineEntriesCheckboxProps as Props } from './types';

export const CombineEntriesCheckbox = memo(({ className, onChange }: Props) => {
  const [checked, setChecked] = useState(false);
  const { selectedValues } = useJobTitleExpanderStore();

  const handleChangeCombine = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.checked;
      setChecked(value);
      onChange?.(value);
    },
    [onChange]
  );
  return (
    <Styled.Wrapper
      className={classnames('CombineEntriesCheckbox', className)}
      sx={SX.root}
    >
      <FormControlLabel
        control={
          <Checkbox
            size="small"
            checked={checked && selectedValues.length >= 2}
            disabled={selectedValues.length < 2}
            onChange={handleChangeCombine}
          />
        }
        label={
          <Stack direction="row" alignItems="center" gap={0.5}>
            <Typography
              component="label"
              aria-disabled={selectedValues.length < 2}
              variant="body4"
              color="grey.500"
            >
              Combine Entries
            </Typography>

            <Tooltip title="How Combine Entries Works? Helps you create stronger titles by blending your keywords. great for getting started.">
              <Icon
                name="info-circle-outline"
                size={16}
                color="grey.500"
                onClick={(e) => e.preventDefault()}
              />
            </Tooltip>
          </Stack>
        }
      />
    </Styled.Wrapper>
  );
});

CombineEntriesCheckbox.displayName = 'CombineEntriesCheckbox';
